import { useQuery } from "@tanstack/react-query"
import { Link } from "react-router-dom"
import GameScreenLayout from "@/components/GameScreenLayout"
import {
  getCityHallRaidStatus,
  getCityHallStatus,
} from "@/api/gameApi"

export default function CityHallPage() {
  const statusQuery = useQuery({
    queryKey: ["city-hall-status"],
    queryFn: getCityHallStatus,
  })

  const raidQuery = useQuery({
    queryKey: ["city-hall-raid"],
    queryFn: getCityHallRaidStatus,
  })

  const status = statusQuery.data
  const raid = raidQuery.data

  return (
    <GameScreenLayout title="Мэрия" backTo="/play">
      {statusQuery.isLoading ? (
        <p className="text-sm text-guardians-muted">Загрузка…</p>
      ) : status ? (
        <div className="space-y-4">
          <section className="rounded-xl border border-white/10 p-4 text-sm">
            <p>Фонд чемпионов: {status.championFundCoins} 🪙</p>
            <p className="text-guardians-muted">
              Сезон {status.seasonMonthKey} · ваши очки: локально {status.myLocalPts}, глобально{" "}
              {status.myGlobalPts}
            </p>
          </section>

          {status.seasonLeaderboard.length ? (
            <section>
              <h3 className="mb-2 text-sm font-medium">Сезон</h3>
              <ol className="space-y-1 text-sm">
                {status.seasonLeaderboard.slice(0, 10).map((row, i) => (
                  <li key={row.userId} className="flex justify-between">
                    <span>
                      {i + 1}. {row.nickname}
                    </span>
                    <span>{row.localPts}</span>
                  </li>
                ))}
              </ol>
            </section>
          ) : null}
        </div>
      ) : null}

      {raid ? (
        <section className="mt-6 rounded-xl border border-amber-500/30 p-4 text-sm">
          <h3 className="font-medium">Городской рейд</h3>
          <p className="text-guardians-muted">
            {raid.isEventDay
              ? `Сегодня событие · ${raid.eventDate ?? ""}`
              : raid.nextRaidLabel ?? "Рейд не активен"}
          </p>
          <Link
            to="/play/city-hall/raid"
            className="mt-2 inline-block text-guardians-accent underline"
          >
            Экран рейда
          </Link>
        </section>
      ) : null}
    </GameScreenLayout>
  )
}
